import { useTranslation } from 'react-i18next';

const LanguageSwitcher = ({ className = '' }) => {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;

    const toggleLanguage = () => {
        const newLang = currentLang === 'th' ? 'en' : 'th';
        i18n.changeLanguage(newLang);
    };

    return (
        <button
            onClick={toggleLanguage}
            className={`flex items-center gap-1 px-2 py-1 rounded border border-gray-300 text-sm hover:bg-gray-100 ${className}`}
            type="button"
        >
            <span>{currentLang === 'th' ? 'TH' : 'EN'}</span>
        </button>
    );
};

export default LanguageSwitcher;
